var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnimalCharities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Wildlife-Protection-Hold--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wildlife Protection Hold Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.37 9.3a8.78 8.78 0 0 0 -0.21 -1.9 0.47 0.47 0 0 1 0.07 -0.4 0.52 0.52 0 0 1 0.32 -0.22A3.43 3.43 0 0 0 17.87 0a3.4 3.4 0 0 0 -3.08 1.93 0.5 0.5 0 0 1 -0.64 0.25 5.72 5.72 0 0 0 -4.32 0A0.47 0.47 0 0 1 9.22 2a3.39 3.39 0 0 0 -3.09 -2 3.43 3.43 0 0 0 -0.68 6.8 0.52 0.52 0 0 1 0.32 0.2 0.47 0.47 0 0 1 0.07 0.38 8.78 8.78 0 0 0 -0.21 1.9c0 3.5 2.08 5.2 6.37 5.2s6.37 -1.68 6.37 -5.18Zm-8.72 -0.17a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm3.7 2.22 -1 1a0.48 0.48 0 0 1 -0.7 0l-1 -1a0.47 0.47 0 0 1 -0.11 -0.54 0.5 0.5 0 0 1 0.46 -0.31h2a0.5 0.5 0 0 1 0.46 0.31 0.47 0.47 0 0 1 -0.11 0.54Zm1 -2.22a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12 15.84a1.4 1.4 0 0 0 -0.45 1.82L5 19.88a0.49 0.49 0 0 1 -0.17 0.68 0.5 0.5 0 0 1 -0.69 -0.17l-1.35 -2.25a2.46 2.46 0 0 1 0.13 -2.48 0.54 0.54 0 0 0 0.08 -0.28V12.5a1.5 1.5 0 0 0 -3 0v5.17a4.5 4.5 0 0 0 1 2.81l2.66 3.33A0.49 0.49 0 0 0 4 24h4a0.5 0.5 0 0 0 0.5 -0.5v-3a4.46 4.46 0 0 0 -0.76 -2.5c-1.88 -2 -2.47 -2.93 -3.62 -2.16Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11a1.5 1.5 0 0 0 -1.5 1.5v2.88a0.54 0.54 0 0 0 0.08 0.28 2.46 2.46 0 0 1 0.13 2.48l-1.35 2.25a0.5 0.5 0 0 1 -0.69 0.17 0.49 0.49 0 0 1 -0.17 -0.68l1.33 -2.22a1.4 1.4 0 0 0 -0.45 -1.82c-1.15 -0.77 -1.74 0.18 -3.62 2.15a4.46 4.46 0 0 0 -0.76 2.5v3a0.5 0.5 0 0 0 0.5 0.5h4a0.49 0.49 0 0 0 0.39 -0.19L23 20.48a4.5 4.5 0 0 0 1 -2.81V12.5a1.5 1.5 0 0 0 -1.5 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnimalCharities);
export default ForwardRef;